import { Icon20 } from 'builder/components/Icon'
import { useI18n } from 'builder/hooks/useI18n'
import { Container, Header, Body } from './styles'

export const AutotailoringDashboardTipBanner = () => {
  const { i18n } = useI18n()

  return (
    <Container>
      <Header>
        <Icon20.Idea />
        {i18n.t('builder.auto_tailoring.overview.dashboard_tip_banner.header')}
      </Header>
      <Body>{i18n.t('builder.auto_tailoring.overview.dashboard_tip_banner.body')}</Body>
    </Container>
  )
}
